import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

import { IconButton } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { openDeleteAcountModal } from "./store/profileSlice";
import { useDeleteAccountMutation } from "./Service/DeleteAccount.service";

import { useNavigate } from "react-router-dom";
import {
  changeCode,
  changeCodeVerify,
  changeDataProfile,
  changeFcmToken,
  changePhone,
  changeToken,
  changeUser,
} from "../Auth/features/Auth";
import { POST_REQUEST } from "../../../HooksApi/useApi";
import { USeInsertData } from "../../../HookAxios/postData";

export function DeleteConfirmationModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector((state) => state.profile.isOpen);
  const token = useSelector((state) => state.Auth.userInfo.token);

  function handelOnSettledData() {
    dispatch(changeUser({}));
    dispatch(changeToken(""));
    dispatch(changePhone(""));
    dispatch(changeCode(""));
    dispatch(changeCodeVerify(""));
    dispatch(changeFcmToken(""));
    dispatch(changeDataProfile({}));
    navigate("/");
  }

  const handleClose = () => {
    dispatch(openDeleteAcountModal());
  };
  const {
    mutate: mutateDeleteAccount,
    isLoading: isLoadingDeleteAccount,
    isSuccess: isSuccessDeleteAccount,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("delete_account", "", { Authorization: `Bearer ${token}` }),
    handelOnSettledData,
  });

  const handleSubmit = () => {
    mutateDeleteAccount();
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: "40px" }}>
          <DialogContentText
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
            id="alert-dialog-description"
          >
            <InfoIcon color="warning" />
            <span>هل انت متأكد من حذف الحساب؟</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: "40px",
            width: "80%",
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={handleSubmit}
            fullWidth
          >
            حذف الحساب
          </Button>

          <Button fullWidth color="error" variant="text" onClick={handleClose}>
            الغاء
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
